// extracted by mini-css-extract-plugin
export default {"navBg":"index_navBg_gI2AG","navCon":"index_navCon_t13Pi"};